import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Wallet, Mail, ArrowLeft, Loader2, Send, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, {
        email: email.trim(),
        origin_url: window.location.origin,
      });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Não foi possível enviar agora. Tente novamente em instantes.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md animate-slide-up">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-emerald-400 to-emerald-600 flex items-center justify-center shadow-lg shadow-emerald-500/40">
            <Wallet className="w-6 h-6 text-slate-900" strokeWidth={2.5} />
          </div>
          <div>
            <p className="font-display text-xl font-bold text-white">Põe na Conta</p>
            <p className="text-xs text-emerald-300">Finanças por voz</p>
          </div>
        </div>

        <div className="pnc-card p-6 sm:p-8 relative overflow-hidden">
          <div className="absolute -top-24 -right-16 w-56 h-56 rounded-full bg-emerald-500/15 blur-3xl pointer-events-none" />
          <div className="relative">
            {sent ? (
              <div className="text-center">
                <div className="w-14 h-14 mx-auto rounded-2xl bg-emerald-500/15 flex items-center justify-center mb-4">
                  <CheckCircle2 className="w-7 h-7 text-emerald-300" />
                </div>
                <h1 className="font-display text-2xl font-bold text-white">Verifique seu e-mail</h1>
                <p className="text-sm text-slate-400 mt-3 leading-relaxed">
                  Se existir uma conta associada a <strong className="text-slate-200">{email}</strong>,
                  enviamos um link para redefinir a senha. O link vale por <strong>60 minutos</strong>.
                </p>
                <p className="text-xs text-slate-500 mt-4">
                  Não chegou? Verifique a caixa de spam ou tente novamente em alguns minutos.
                </p>
                <Link
                  data-testid="forgot-password-back-login"
                  to="/entrar"
                  className="mt-6 inline-flex items-center gap-2 text-emerald-300 hover:text-emerald-200 text-sm underline underline-offset-4"
                >
                  <ArrowLeft className="w-4 h-4" /> Voltar para entrar
                </Link>
              </div>
            ) : (
              <>
                <h1 className="font-display text-2xl font-bold text-white">Esqueci minha senha</h1>
                <p className="text-sm text-slate-400 mt-2">
                  Informe o e-mail da sua conta e enviaremos um link seguro para você criar uma nova senha.
                </p>

                <form onSubmit={submit} className="mt-6 space-y-4">
                  <label className="block">
                    <span className="text-[11px] uppercase tracking-wider text-slate-400 font-semibold">E-mail</span>
                    <div className="mt-1.5 flex items-center gap-2.5 px-4 py-3 rounded-2xl bg-slate-900/70 border border-white/10 focus-within:border-emerald-400/60 focus-within:bg-slate-900 transition-colors">
                      <Mail className="w-4 h-4 text-slate-500 shrink-0" />
                      <input
                        data-testid="forgot-password-email-input"
                        type="email"
                        required
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="voce@exemplo.com"
                        className="w-full bg-transparent outline-none text-white placeholder:text-slate-500 text-sm"
                      />
                    </div>
                  </label>

                  <button
                    data-testid="forgot-password-submit-btn"
                    type="submit"
                    disabled={loading}
                    className="btn-emerald w-full py-3.5 rounded-2xl flex items-center justify-center gap-2 text-sm disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />}
                    {loading ? "Enviando…" : "Enviar link de recuperação"}
                  </button>
                </form>

                <div className="mt-6 text-center">
                  <Link
                    to="/entrar"
                    className="inline-flex items-center gap-2 text-xs text-slate-400 hover:text-white underline underline-offset-4"
                  >
                    <ArrowLeft className="w-3.5 h-3.5" /> Voltar para entrar
                  </Link>
                </div>
              </>
            )}
          </div>
        </div>

        <p className="text-center text-xs text-slate-500 mt-6">
          © 2026 Põe na Conta • suporte@poenaconta.ia.br
        </p>
      </div>
    </div>
  );
}
